import React from "react"
import Image from "next/image"
import Link from "next/link"
import { ImageItem } from "./types"

type Props = {
  featuredItems: ImageItem[]
}

const SideProductsBar = ({ featuredItems }: Props) => {
  const S3_IMAGE_BASE_URL = process.env.NEXT_PUBLIC_S3_IMAGE_BASE_URL
  const topCategoryItemsMaps = Array.isArray(featuredItems)
    ? featuredItems
    : JSON.parse(featuredItems || "[]");

  return (
    <div className="flex flex-col sm:flex-col md:flex-row lg:flex-col  gap-6 ">
      {topCategoryItemsMaps.map((item: ImageItem) => (
        <div className="w-full h-full cursor-pointer" key={item.name}>
          <div className="aspect-[1011/400] relative rounded-xl overflow-hidden md:h-[186px] lg:h-[148px] xl:h-[168px] ">
            <Link href={`/categories/${item.product_category_handle}`}>
              <Image
                src={`${S3_IMAGE_BASE_URL}${item.image}`}
                alt={item.name}
                fill
                objectFit="cover"
              />
            </Link>
          </div>
        </div>
      ))}
    </div>
  )
}

export default SideProductsBar
